"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHourlyMsAtValueFromSnapshots = exports.getMsAtValueFromSnapshots = void 0;
var moment = require("moment");
var SortHelper_1 = require("./SortHelper");
var getMsAtValueFromSnapshots = function (snapshots, targetValue, from, to, valueAtBeginningOfRange) {
    var sortedSnapshots = snapshots.sort((0, SortHelper_1.sortAsc)("snapshot"));
    var ms = 0;
    for (var index = 0; index < sortedSnapshots.length; index += 1) {
        var _a = sortedSnapshots[index], snapshot = _a.snapshot, value = _a.value;
        var match = value == targetValue;
        if (!match && typeof value == "string" && typeof targetValue == "string") {
            match = targetValue.toLowerCase() == value.toLowerCase();
        }
        if (typeof value == "string" && match) {
            if (index == 0) {
                var firstMatches = valueAtBeginningOfRange == targetValue;
                if (valueAtBeginningOfRange === undefined || valueAtBeginningOfRange === null) {
                    firstMatches = true;
                }
                if (!firstMatches && typeof valueAtBeginningOfRange == "string" && typeof targetValue == "string") {
                    firstMatches = targetValue.toLowerCase() == valueAtBeginningOfRange.toLowerCase();
                }
                if (firstMatches)
                    ms += snapshot - +from;
            }
            else {
                ms += snapshot - sortedSnapshots[index - 1].snapshot;
            }
            if (index == sortedSnapshots.length - 1) {
                ms += +to - snapshot;
            }
        }
    }
    return ms;
};
exports.getMsAtValueFromSnapshots = getMsAtValueFromSnapshots;
var getHourlyMsAtValueFromSnapshots = function (snapshots, targetValue, from, to) {
    var sortedSnapshots = snapshots.sort((0, SortHelper_1.sortAsc)("snapshot"));
    var hourlyData = [];
    var _loop_1 = function (index) {
        var _a = sortedSnapshots[index], snapshot = _a.snapshot, value = _a.value;
        var startOfHour = +moment(snapshot).startOf("hour").toDate(), updateHourlyIndex = hourlyData.findIndex(function (_a) {
            var timestamp = _a.timestamp;
            return +timestamp == startOfHour;
        });
        if (updateHourlyIndex >= 0) {
            hourlyData[updateHourlyIndex] = __assign(__assign({}, hourlyData[updateHourlyIndex]), { items: __spreadArray(__spreadArray([], hourlyData[updateHourlyIndex].items, true), [{ value: value, snapshot: snapshot }], false) });
        }
        else {
            var valueAtStartOfHour = value;
            var itemsBeforeHour = sortedSnapshots.filter(function (_a) {
                var snapshot = _a.snapshot;
                return snapshot < startOfHour;
            });
            if (itemsBeforeHour.length > 0)
                valueAtStartOfHour = itemsBeforeHour[itemsBeforeHour.length - 1].value;
            hourlyData.push({
                timestamp: new Date(startOfHour),
                valueAtStartOfHour: valueAtStartOfHour,
                items: [{ value: value, snapshot: snapshot }]
            });
        }
    };
    for (var index = 0; index < sortedSnapshots.length; index += 1) {
        _loop_1(index);
    }
    var hourly = hourlyData.map(function (_a) {
        var items = _a.items, valueAtStartOfHour = _a.valueAtStartOfHour, timestamp = _a.timestamp;
        var from = timestamp, to = moment(timestamp).endOf("hour").toDate(), ms = (0, exports.getMsAtValueFromSnapshots)(items, targetValue, from, to, valueAtStartOfHour);
        return {
            timestamp: timestamp,
            ms: ms,
            percent: ms / (+to - +from)
        };
    });
    var returnData = [];
    if (from && to) {
        var backfillCursor_1 = +moment(from).startOf("hour").toDate();
        while (+backfillCursor_1 < +to) {
            var existingHourlyData = hourly.find(function (_a) {
                var timestamp = _a.timestamp;
                return +timestamp == backfillCursor_1;
            });
            if (existingHourlyData) {
                returnData.push(existingHourlyData);
            }
            else {
                returnData.push({
                    timestamp: new Date(backfillCursor_1),
                    ms: 0,
                    percent: 0
                });
            }
            backfillCursor_1 += 1000 * 60 * 60;
        }
    }
    else {
        returnData = hourly;
    }
    return returnData;
};
exports.getHourlyMsAtValueFromSnapshots = getHourlyMsAtValueFromSnapshots;
